import React, { useState } from 'react';
import { Box, Button,  VStack, Heading, Span } from '@bpba/ui-components';
import { useMutation, useQuery } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { Queries } from '../rest/Queries';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { SubmitHandler, useFieldArray, useForm } from 'react-hook-form';
import { Localidad } from '../rest/models/Localidad';
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { CajasDeSeguridadModel } from "../rest/models/CajasDeSeguridadModel";
import { ValidarCuitRQ } from "../rest/models/ValidarCuitRQ";
import { postCajasDeSeguridad } from "../rest/mutations/postCajasDeSeguridad";
import { getSucursalesCajas } from "../rest/queries/getSucursalesCajas";
import { SucursalesCajaModel } from '../rest/models/SucursalesCajaModel';
import { postEsClienteCajas } from '../rest/mutations/postEsClienteCajas';
import { CajasDeSeguridadRQ } from '../rest/models/CajasDeSeguridadRQ';
import {useParams } from 'react-router-dom';
import { getCajasDisponibles } from '../rest/queries/getCajasDisponibles';
import { CofreModel } from '../rest/models/Cofre';
import { Result } from './Result';
import { ResultExito } from './ResultExito';
import { ResultError } from './ResultError';


const validateRealCuit = (cuit: string) => {
    let rv = false;

    let resultado = 0;
    const codes = "6789456789";
    let verificador = parseInt(cuit[cuit.length - 1]);
    let x = 0;

    while (x < 10) {
        let digitoValidador = parseInt(codes.substring(x, x + 1));
        if (isNaN(digitoValidador)) digitoValidador = 0;
        let digito = parseInt(cuit.substring(x, x + 1));
        if (isNaN(digito)) digito = 0;
        let digitoValidacion = digitoValidador * digito;
        resultado += digitoValidacion;
        x++;
    }
    resultado = resultado % 11;
    rv = resultado === verificador;

    return rv ? rv : "Verifique el Cuit ingresado";
};



const ComponenteCajasDeSeguridad: React.FC = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');

    const { register, control, handleSubmit, reset, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            apoderado: [{ nombre: '', cuit: undefined }],
            razonSocial: "",
            email: ""
        }
    });


    const { fields, append, remove } = useFieldArray({
        control,
        name: 'apoderado'
    });

    const { id: tipoPersona } = useParams<string>()
    const [showFullForm, toggleFullForm] = useState<boolean>(false)
    const REQUIRED_FIELD = "Campo requerido.";
    //eslint-disable-next-line
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const [cuitValidado, setCuitValidado] = useState<boolean>(false);
    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<string>("");
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>();
    const [idSucCajas, setIdSucCajas] = useState<string>();
    const [cajaElegida, setCajaElegida] = useState<string>();
    const { data: { localidades } = {} } = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });
    const [postCajaDeSeguridad, { loading: loadingCajas}] = useMutation<Mutations>(postCajasDeSeguridad);
    const [postValidarCuitApi, { loading: loadingValidarCuit }] = useMutation<Mutations>(postEsClienteCajas);
    const { data: { sucursalesCaja } = {}, loading: loadingSucCaja } = useQuery<Queries>(getSucursalesCajas);
    const { data: { cajasDisponibles } = {}} = 
    useQuery<Queries>(getCajasDisponibles, { variables: { idSucCaja: idSucCajas }, skip: !idSucCajas,onCompleted(data) {
   
     if(!data.cajasDisponibles){
        setErrorServicio(true);
        setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.");
     }else{
        setErrorServicio(false);
        setMensajeError("");
     }   
    },onError(e: any) {
   
        if (e.networkError.statusCode === 409) {
            setErrorServicio(true);
            setMensajeError(JSON.parse(JSON.stringify(e.networkError)).result.Message);
         
        }
       }});
    const getTipoCajaFromList = (tipoCaja: any) => { return cajasDisponibles?.cofres?.find((caja) => caja.modelo === tipoCaja); };
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [tokenCuit, setTokenCuit] = useState("");
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");
    



    const ValidarCuit = async (data: CajasDeSeguridadModel) => {


        const token = executeRecaptcha && (await executeRecaptcha('ValidarCuit'));
        let datos: ValidarCuitRQ = {
            "cuit": data.cuit.toString(),
            "apoderados": [],
            "googleToken": token,
            "sistema": "cajadeseguridad",
            "linea": ""
        }


        postValidarCuitApi({ variables: { input: datos } }).then(response => {
            
            if(response.data?.esClienteCajas){
                setTokenCuit(response.data!.esClienteCajas.token);
                if (response.data!.esClienteCajas.baseNegativa) {
                    setCuitValidado(true);
                    setMensajeError("");
                    toggleFullForm(true);
                    
                }
                else {
                    setErrorServicio(true);
                    setMensajeError("Lo sentimos no resulta posible procesar tu solicitud por este medio. Por favor, acercate a una sucursal para gestionar tu consulta.");

                }
            }else{
                setErrorServicio(true);
                setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        }).catch((e: any) => {
            if (e.networkError.statusCode === 409) {
                setErrorServicio(true);
                setMensajeError(JSON.parse(JSON.stringify(e.networkError)).result.Message);
             
            } else {
                
                setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.");
            } 
        } )
    }




    const onSubmit: SubmitHandler<CajasDeSeguridadModel> = async (data: CajasDeSeguridadModel) => showFullForm ? SubmitForm(data) : ValidarCuit(data)


    const cajaSeleccionada = getTipoCajaFromList(cajaElegida);

    const SubmitForm: SubmitHandler<CajasDeSeguridadModel> = async (data: CajasDeSeguridadModel) => {

        let datos: CajasDeSeguridadRQ = {
            "token": tokenCuit,
            "cuit": Number(data.cuit),
            "razonSocial": data.razonSocial,
            "email": data.email,
            "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
            "sucursal": Number(idSucCajas),
            "localidad": data.provincia.split('-')[1] + "," + data.localidad + " " + data.calle + "," + data.numeroCalle + "," + data.piso,
            "origenSolicitud": origenSolicitud ? origenSolicitud : "",
            "modelo": cajaSeleccionada?.modelo ? cajaSeleccionada?.modelo : "",
            "seccion": cajaSeleccionada?.numeroSeccion ? cajaSeleccionada?.numeroSeccion : "",
            "caja":  "",
            "tipoPersona": Number(tipoPersona),
            "apoderados": data.apoderado
        }
        postCajaDeSeguridad({ variables: { input: datos} }).then((response:any) => {
            
            if (!response.data.cajasDeSeguridadRQ) {
                
                setServicioOk(true);
                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                
            }else{
                setServicioOk(true);
                setMensajeRtaServicio("Solicitud creada con éxito.En los próximos días nos contactaremos con vos.");
            }
        }).catch((e) => {
            setServicioOk(false);
            setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
            
        })
    }


    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);

    }
   

    if (loadingValidarCuit || loadingCajas || loadingSucCaja) return <SpinnerCajas />;
    const handleReset = () => {
        reset({});
        window.location.reload();
      };
    if (servicioOk) return (

        <Result handleReset={handleReset}>
            <ResultExito message={mensajeRtaServicio}></ResultExito>
        </Result>
        
    );
   if (mensajeErrorPostProspecto!=="" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );
  
    
    
    return (

        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {!cuitValidado ?

                        (<>
                            <Heading level={3} mb={0} fontWeight={400} tabIndex={0}>
                                Cajas de seguridad disponibles
                            </Heading>
                            {errorServicio?
                                <VStack mt={"20px"}>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {mensajeError}
                                    </Span>
                                </VStack>:<></>
                            }   
                            <VStack mt={"20px"}>
                                <select tabIndex={0} aria-label={"Seleccione la sucursal"}
                                    {...register("sucursalCaja", { required: REQUIRED_FIELD })}
                                    onChange={(e: any) => setIdSucCajas(e.target.value.toString())} name="sucursalCaja">
                                    <option value="" selected > Seleccione sucursal </option>
                                    {sucursalesCaja &&
                                         sucursalesCaja.slice().sort((a, b) => a.cod_ubic > b.cod_ubic ? 1 : -1)
                                        .map((item: SucursalesCajaModel) =>
                                            <option value={item.cod_ubic} key={item.cod_ubic}>{ item.cod_ubic+ ", " +item.suc_nombre  }</option>
                                        )}

                                </select>

                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.sucursalCaja?"* "+errors.sucursalCaja.message:""}
                                </Span>

                            </VStack>
                            <VStack mt={"20px"}>
                                <select tabIndex={0} aria-label={"Seleccione la caja"}
                                    {...register("tipoCaja", { required: REQUIRED_FIELD })}
                                    onChange={(e) => { setCajaElegida(e.target.value)}}
                                    name="tipoCaja">
                                    <option value="" selected>Seleccione caja</option>
                                    {cajasDisponibles &&
                                        cajasDisponibles.cofres.map((item: CofreModel) =>
                                            <option value={item.modelo} key={item.modelo}>{item.dimensiones}</option>
                                    )
                                    }

                                </select>
                                {cajasDisponibles && cajasDisponibles.cofres?.length===0?
                                    (<Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {"En esta sucursal no se encuentran cajas disponibles. Por favor seleccione otra"}
                                    </Span>)
                                :(<></>)}
                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {errors.tipoCaja?"* "+errors.tipoCaja.message:""}
                                </Span>

                            </VStack>
                            
                            <VStack mt={"20px"}>
                                <input type={"text"} tabIndex={0}
                                    {...register("cuit", {
                                        required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                        maxLength: 11, validate: (value) => validateRealCuit(value.toString())
                                    })}
                                    name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {errors.cuit?"* "+errors.cuit.message:""}
                                </Span>
                                <Button type="submit" variant="secondary" py={"10px !important"}>Validar</Button>
                            </VStack>
                        </>)
                        : (<>
                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                Datos Generales
                            </Heading>
                            {errorServicio?
                                <VStack mt={"20px"}>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {mensajeError}
                                    </Span>
                                </VStack>:<></>
                            }  
                            <VStack mt={"20px"}>
                                <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{lineHeight:"18px"}} tabIndex={0}>
                                    Sucursal de la caja
                                </Span>
                                <select disabled style={{ width: "100%", height: '2.5em' }} tabIndex={0}>
                                    <option selected>{idSucCajas}</option>

                                </select>
                                <Span color="primary.0" mt={"20px"} marginBottom={"8px"} fontSize={"14px"} style={{lineHeight:"18px"}} tabIndex={0}>
                                    Tipo de caja seleccionada
                                </Span>
                                <select disabled style={{ width: "100%", height: '2.5em' }} tabIndex={0}>
                                    <option selected>{cajaSeleccionada?.dimensiones +" - "+cajaSeleccionada?.tarifa}</option>

                                </select>
                            </VStack>
                            <VStack mt={"20px"}>

                                <input {...register(`razonSocial`, { required: REQUIRED_FIELD, maxLength: 100 })} name='razonSocial' type={"text"} defaultValue={""} placeholder='Nombre y apellido / Razón social' maxLength={100}/>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial?"* "+errors.razonSocial.message:""}</Span>
                            </VStack>
                            <VStack mt={"20px"}>
                                <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email?"* "+errors.email.message:""}</Span>
                            </VStack>
                            <VStack mt={"20px"}>
                                <Span color="primary.0" fontSize={"14px"} style={{lineHeight:"18px"}} tabIndex={0}>
                                    Nombre y apellido del apoderado / representante legal / firmante de la PPJJ
                                </Span>
                                {fields.map((item, index) => (<>
                                    <VStack mt={"8px"}>
                                        <Box key={`apoderado-${index}`} display={'flex'}>

                                            <Box id={`apoderado-${index}`} justifyContent={'space-between'} display={'flex'} flexDirection={'row'}>
                                                <VStack  mr={"0.5rem"}>
                                                    <input id={`nombre-${item.id}`}  {...register(`apoderado.${index}.nombre`, { required: REQUIRED_FIELD, maxLength: 25 })} type="text" placeholder='Nombre Completo Apoderado' maxLength={25} style={{paddingRight: "5px"}}/>
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderado[index]?.nombre?"* "+errors.apoderado[index]?.nombre.message:""}</Span>
                                                </VStack>
                                                <VStack  mr={"0.5rem"}>
                                                    <input id={`cuit-${item.id}`} {...register(`apoderado.${index}.cuit`, { required: REQUIRED_FIELD, maxLength: 11, minLength: { value: 11, message: "cantidad minima de caracteres: 11" }, validate: (value) => validateRealCuit(value.toString()) })}
                                                        maxLength={11} minLength={11} type="text" placeholder='CUIT ej: 30123456789'/>
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderado[index]?.cuit?"* "+errors.apoderado[index]?.cuit.message:""}</Span>
                                                </VStack>
                                            </Box>
                                            <Button style={{ backgroundColor: '#cb3a3a', width:'30%', height:"calc(1.8em + 0.75rem + 2px)" }} id={`btn-${item.id}`} type="button" variant={'primary'} onClick={() => remove(index)} mt={'14px !important'} py={'10px !important'}>Eliminar</Button>

                                        </Box>
                                    </VStack>

                                </>
                                ))}
                                <Button style={{ width:"fit-content",height:"calc(1.8em + 0.75rem + 2px)" }} id={`btn-+`} type="button" variant={'primary'} onClick={() => append({ nombre: '', cuit: undefined })} py={'10px !important'}>Agregar apoderado</Button>
                            </VStack>
                            <VStack mt={"20px"}>
                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{lineHeight:"18px"}}>
                                    Teléfono de contacto
                                </Span>
                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea?"* "+errors.telefonoArea.message:""}</Span>
                                    </VStack>
                                    <VStack>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono?"* "+errors.telefono.message:""}</Span>
                                    </VStack>
                                </VStack>
                            </VStack>
                            <VStack mt={"20px"}>
                                <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{lineHeight:"18px"}} tabIndex={0}>Domicilio Real / Legal </Span>

                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                            style={{ width: "100%" }}
                                            {...register("provincia", { required: REQUIRED_FIELD })}
                                            onChange={(e: any) => BuscLoc(e.target.value)} name="provincia" placeholder='Provincia' >
                                            <option value="">Provincia</option>
                                            <option value="2-Buenos Aires">Buenos Aires</option>
                                            <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provincia?"* "+errors.provincia.message:""}</Span>
                                    </VStack>
                                    <VStack >
                                        <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidad", { required: REQUIRED_FIELD })} name="localidad" placeholder='Localidad' >
                                            <option value="" selected >Localidad </option>
                                            {localidades &&
                                                localidades.map((item: Localidad) =>
                                                    <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                )}
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidad?"* "+errors.localidad.message:""}</Span>
                                    </VStack>
                                </VStack>


                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mt={"20px"} mr={"0.5rem"}>
                                        <input tabIndex={0}{...register("calle", { required: REQUIRED_FIELD, maxLength: 50 })} name="calle" placeholder='Calle' maxLength={50} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calle?"* "+errors.calle.message:""}</Span>
                                    </VStack>
                                    <VStack mt={"20px"} mr={"0.5rem"}>
                                        <input tabIndex={0}{...register("numeroCalle", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalle" placeholder='Nro' maxLength={5} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalle?"* "+errors.numeroCalle.message:""}</Span>
                                    </VStack>
                                    <VStack mt={"20px"}>
                                        <input tabIndex={0}{...register("piso", { required: false, maxLength: 8, })} name="piso" placeholder='Piso' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.piso?.message}</Span>
                                    </VStack>

                                </VStack>


                                
                                <Button type="submit" variant="secondary" marginBottom={"24px"} style={{height:"calc(1.8em + 0.75rem + 2px)"}} py={'10px !important'}>Enviar</Button>
                            </VStack>

                        </>)

                    }




                </form>
            </VStack>

        </Box>

    )
    
};



export default ComponenteCajasDeSeguridad;
